module.exports = __webpack_public_path__ + "assets/images/project/constituencies/potong-pasir-smc.jpg?v=fee173a0";